import { GROUP_AUTH_HEADER_NAME } from "@/constants/axios";
import type {
  GetPresignedUrlPayload,
  PostPresignedUrlPayload,
  PresignedUrlResponse,
} from "@/core/types";
import type { AptiRequestConfig } from "@/lib/types/api";
import { getGroupAuthType } from "@/redux/actions/auth";

import { httpAuth } from "../utils/axios";

export const sharedRequestsTyped = {
  get_presigned_url: function ({
    data,
    version = "v4",
  }: {
    data: GetPresignedUrlPayload;
    version?: string;
  }): Promise<PresignedUrlResponse> {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params: { showLoader: false },
      url: `/${version}/provider/get_presigned_url`,
    } satisfies AptiRequestConfig<GetPresignedUrlPayload>;

    return httpAuth(config) as unknown as Promise<PresignedUrlResponse>;
  },

  post_presigned_url: function ({
    data,
    version = "v4",
  }: {
    data: PostPresignedUrlPayload;
    version?: string;
  }): Promise<PresignedUrlResponse> {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params: { showLoader: false },
      url: `/${version}/provider/get_presigned_url`,
    } satisfies AptiRequestConfig<PostPresignedUrlPayload>;

    return httpAuth(config) as unknown as Promise<PresignedUrlResponse>;
  },
};
